<template>
   <div class="todo-footer" ref="todoContainerFooterElement">
     <span class="todo-footer__items-left">3 items left</span>
     <FooterTabsForDesktop 
        @active-todos="$emit('active-todos')"
        @all-todos="$emit('all-todos')"
        @completed-todos="$emit('completed-todos')"
    >
    </FooterTabsForDesktop>
     <button class="todo-footer__clear-completed-btn" @click="$emit('clear-completed')">Clear Completed</button>
   </div>
</template>

<script>
import FooterTabsForDesktop from "../Tabs/TheFooterTabsDesktop.vue";

export default {
    name: "TheTodoContainerFooter",
    components: { FooterTabsForDesktop },
}
</script>

<style>
    
.todo-footer {
    --padding: 24px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--bg-todo-clr);
    padding: 0 var(--padding);
    height: var(--todo-footer-height);
    width: calc( 100% - (var(--padding) * 2) );
    font-size: var(--todo-footer-font-size); /* should be fluid */
    position: relative;
}

.todo-footer__items-left {
    display: inline-block;
    font-size: inherit;
    color: var(--todo-footer-clr);
    white-space: nowrap;
}

.todo-footer__clear-completed-btn {
    height: var(--todo-footer-height);
    background-color: transparent;
    border: none;
    transition: color 250ms;
    font-size: inherit;
    color: var(--todo-footer-clr);
    white-space: nowrap;
    transition: padding 300ms;
}

.todo-footer__clear-completed-btn:focus {
    outline: solid 1.5px var(--todo-border-clr);
    height: calc(var(--todo-footer-height) - 3px);
    padding: 0 10px; /* yes. I know it's bad. Affects performance */
}

</style>